import { createReducer, on } from '@ngrx/store';
import {
	loadVerfahrenAktionStatistikSuccessAction,
	monthlyStatistikLoadedAction,
	statistikLoadedAction,
	zaehlblattStatistikLoadedAction,
} from './statistik.actions';
import {
	MonthlyStatistik,
	StatistikResource,
	VerfahrenAktionStatistik,
	ZaehlblattStatistikResource,
} from './statistik.model';

export interface StatistikState {
	statistik: StatistikResource;
	monthlyStatistik: MonthlyStatistik;
	zaehlblattStatistik: ZaehlblattStatistikResource;
	verfahrenAktionStatistik: VerfahrenAktionStatistik;
}

export const initialState: StatistikState = {
	statistik: null,
	monthlyStatistik: null,
	zaehlblattStatistik: null,
	verfahrenAktionStatistik: null,
};

export const statistikReducer = createReducer(
	initialState,
	on(statistikLoadedAction, (state: StatistikState, { statistik }): StatistikState => ({
		...state,
		statistik,
	})),
	on(monthlyStatistikLoadedAction, (state: StatistikState, { statistik }): StatistikState => ({
		...state,
		monthlyStatistik: statistik,
	})),
	on(zaehlblattStatistikLoadedAction, (state: StatistikState, { statistik }): StatistikState => ({
		...state,
		zaehlblattStatistik: statistik,
	})),
	on(loadVerfahrenAktionStatistikSuccessAction, (state: StatistikState, { statistik }): StatistikState => ({
		...state,
		verfahrenAktionStatistik: statistik,
	}))
);
